import React, { Component } from 'react'

const PhanQuyenNguoiDung = () => {
    return (
      <div>PhanQuyenNguoiDung</div>
    )
}

export default PhanQuyenNguoiDung